"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PrivateKey = void 0;
const react_1 = __importStar(require("react"));
const button_1 = __importDefault(require("../components/button"));
const connector_screen_1 = __importDefault(require("../components/connector-screen"));
const connectors_1 = require("../connectors");
const use_theme_1 = __importDefault(require("../hooks/use-theme"));
const use_celo_1 = require("../use-celo");
const tailwind_1 = __importDefault(require("../utils/tailwind"));
const styles = (0, tailwind_1.default)({
    disclaimer: `
    tw-text-sm
    tw-mt-2`,
    textareaContainer: `
    tw-flex
    tw-flex-col`,
    textarea: `
    tw-border
    tw-rounded-md
    tw-mt-3
    tw-px-3
    tw-py-2
    tw-font-mono`,
    button: `
    tw-mt-3
    tw-px-4
    tw-py-2`,
});
const PrivateKey = ({ onSubmit }) => {
    const theme = (0, use_theme_1.default)();
    const [value, setValue] = (0, react_1.useState)('');
    const { network, feeCurrency, initConnector } = (0, use_celo_1.useCeloInternal)();
    const handleSubmit = (0, react_1.useCallback)(() => __awaiter(void 0, void 0, void 0, function* () {
        if (!value) {
            return;
        }
        const connector = new connectors_1.PrivateKeyConnector(network, value, feeCurrency);
        yield initConnector(connector);
        void onSubmit(connector);
    }), [feeCurrency, network, value, onSubmit, initConnector]);
    return (react_1.default.createElement(connector_screen_1.default, { title: "Enter your plaintext private key", content: react_1.default.createElement("div", { style: { color: theme.textSecondary } },
            react_1.default.createElement("p", { className: styles.disclaimer }, "This will be saved locally, so be sure to logout before leaving this computer unattended."),
            react_1.default.createElement("div", { className: styles.textareaContainer },
                react_1.default.createElement("textarea", { className: styles.textarea, style: { borderColor: theme.muted }, value: value, onChange: (e) => setValue(e.target.value) }),
                react_1.default.createElement(button_1.default, { as: "button", className: styles.button, onClick: handleSubmit }, "Submit"))), footer: {
            desc: 'Not sure where to find your Private Key?',
            url: 'https://docs.celo.org/key-concepts',
            CTA: 'Learn',
        } }));
};
exports.PrivateKey = PrivateKey;
//# sourceMappingURL=private-key.js.map